import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}
      >
        Payment Successful
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <CheckCircleIcon
            sx={{
              fontSize: 80,
              color: "green",
              animation: "pop 0.3s ease-in-out",
            }}
          />
          <Typography variant="body1" sx={{ mt: 2 }}>
            Your payment was successful! Thank You...
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
